import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CountdownTimer } from './ui/CountdownTimer';
import { fireAddToCart, fireInitiateCheckout } from './MetaPixel';
export function Pricing() {
  const handleCtaClick = () => {
    fireAddToCart();
    fireInitiateCheckout();
  };
  return <Section className="py-32" id="price-section" data-id="element-76">
      <div className="max-w-5xl mx-auto border border-luxury-gold/30 bg-luxury-charcoal relative overflow-hidden" data-id="element-77">
        {/* Badge */}
        <div className="flex justify-center pt-8 pb-4" data-id="element-78">
          <div className="bg-luxury-gold text-luxury-black px-6 py-2 text-xs uppercase tracking-widest font-bold shadow-lg shadow-luxury-gold/20" data-id="element-79">
            Limited Time
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center px-8 md:px-12 py-12" data-id="element-80">
          {/* Left Column: Product Image */}
          <div className="relative group flex justify-center md:justify-end" data-id="element-81">
            <div className="absolute inset-0 bg-luxury-gold/20 blur-3xl rounded-full opacity-20 group-hover:opacity-40 transition-opacity duration-700" data-id="element-82" />
            <img src="https://cdn.magicpatterns.com/uploads/eNabV6EjgNXjyH8oHFnFr3/Ebook_portada.png" alt="The Luxury Content System Ebook Cover" className="relative w-full max-w-[320px] shadow-2xl shadow-black/50 border border-white/5 transform group-hover:scale-[1.02] transition-transform duration-500 ease-out" data-id="element-83" />
          </div>

          {/* Right Column: Pricing Details */}
          <div className="text-center md:text-left space-y-6" data-id="element-84">
            <div data-id="element-85">
              <p className="text-luxury-gold text-xs uppercase tracking-[0.3em] font-bold mb-4" data-id="element-86">
                Limited Time Offer
              </p>
              <h2 className="font-serif text-4xl md:text-5xl text-white mb-2 leading-tight" data-id="element-87">
                Launch Access
              </h2>
              <p className="text-luxury-gray font-light" data-id="element-88">
                The complete system to restructure your digital presence.
              </p>
            </div>

            <div className="flex flex-col items-center md:items-start space-y-2" data-id="element-89">
              <span className="text-luxury-gray text-lg uppercase tracking-widest" data-id="element-90">
                System Value{' '}
                <span className="line-through decoration-luxury-gold/50 decoration-2" data-id="element-91">
                  $149
                </span>
              </span>
              <div className="flex items-baseline gap-4" data-id="element-92">
                <span className="text-6xl md:text-7xl font-serif text-luxury-gold" data-id="element-93">
                  Today $14.99
                </span>
              </div>
              <div className="flex gap-4 text-xs text-luxury-gray/60 uppercase tracking-wider" data-id="element-94">
                <span data-id="element-95">One-time payment</span>
                <span data-id="element-96">•</span>
                <span data-id="element-97">Instant access</span>
              </div>
            </div>

            <CountdownTimer data-id="element-98" />

            <div className="pt-2" data-id="element-99">
              <Button href="https://learn.alexaaanarvaez.in/cart/43580187443265:1" fullWidth withArrow className="shadow-lg shadow-luxury-gold/10 hover:shadow-luxury-gold/20" onClick={handleCtaClick} data-id="element-100">
                Get Instant Access
              </Button>
              <p className="text-center text-xs text-luxury-gray/40 mt-3" data-id="element-101">
                Price may increase
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}